var __jsx = React.createElement;
import { cn } from '@lib/cn';
import { ANIMATION_DURATIONS_MS } from '@lib/constants';
import React, { useEffect, useRef, useState } from 'react';
const ExtendAnimatedDiv = _ref => {
  let {
    className,
    isOpen,
    children,
    animationDurationMs = ANIMATION_DURATIONS_MS.fast,
    onCloseCallback = () => {},
    onOpenCallback = () => {},
    beforeAnimationCallback = () => {},
    afterAnimationCallback = () => {}
  } = _ref;
  const extendedContentRef = useRef(null);
  const {
    0: isExtended,
    1: setIsExtended
  } = useState(false);
  const {
    0: currentHeight,
    1: setCurrentHeight
  } = useState('0px');
  useEffect(() => {
    if (extendedContentRef.current) {
      beforeAnimationCallback();
      if (isOpen) {
        setIsExtended(true);
        // Timeout waits for the children component to be rendered before getting the height
        setTimeout(() => {
          if (extendedContentRef.current) {
            const currentHeight = extendedContentRef.current.scrollHeight + 'px';
            setCurrentHeight(currentHeight);

            // This causes the animation to start
            extendedContentRef.current.style.height = currentHeight;

            // setTimeout is used to wait for the height to be set before setting it to fit-content, just animation purposes
            setTimeout(() => {
              if (extendedContentRef.current && isOpen) {
                extendedContentRef.current.style.height = 'fit-content';
                extendedContentRef.current.style.overflow = 'visible';
              }
              onOpenCallback();
              afterAnimationCallback();
            }, animationDurationMs);
          }
        }, 50);
      } else {
        setIsExtended(false);
        extendedContentRef.current.style.height = currentHeight;
        extendedContentRef.current.style.overflow = 'hidden';
        // setTimeout is used to wait for the height to be set before setting it to 0px, just animation purposes
        setTimeout(() => {
          if (extendedContentRef.current) {
            extendedContentRef.current.style.height = '0px';
          }
        }); // No ms is needed because the transition is not applied when setting the height to 0px
        // setTimeout is used to wait for the transition to finish before setting the extendedContent to an empty element, just animation purposes
        setTimeout(() => {
          onCloseCallback();
          afterAnimationCallback();
        }, animationDurationMs);
      }
    }
  }, [isOpen, extendedContentRef.current]);
  return __jsx("div", {
    ref: extendedContentRef,
    className: cn('overflow-hidden translate-y-[-1px]', className),
    style: {
      transition: "height ".concat(animationDurationMs, "ms ease"),
      height: 0,
      willChange: 'height',
      transform: 'translate3d(0, -1px, 0) scale(1)'
    }
  }, isExtended ? children : null);
};
export default ExtendAnimatedDiv;